(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const {
  rowPrice
} = svs.numbergames.rules.EUROJACKPOT;
const {
  playPackages
} = svs.eurojackpot.data.cms;
const PlayButtons = () => {
  const sortedPlayPackages = [...playPackages].sort((a, b) => a.rows - b.rows);
  const handleClick = (numberOfRows, price) => {
    svs.components.analytics.trackEvent({
      category: 'eurojackpot_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(numberOfRows, " rader"),
      opt_value: price
    }, () => {
      svs.utils.url.navigate("/eurojackpot/spela?rader=".concat(numberOfRows, "&dag=n"));
    });
  };
  const [firstDraw] = svs.numbergames.draws.drawsUtils.sortProductsByDrawTime(productMapping.CONSTANTS.EUROJACKPOT);
  const date = new Date(firstDraw.regCloseTime);
  let day;
  switch (true) {
    case dateFns.isToday(date):
      day = 'idag';
      break;
    case dateFns.isTomorrow(date):
      day = 'imorgon';
      break;
    default:
      day = productMapping.getDay(firstDraw === null || firstDraw === void 0 ? void 0 : firstDraw.productItsId).toLowerCase();
  }
  const drawTitle = "Dragning ".concat(day);
  return React.createElement("div", {
    className: "eurojackpot-play-buttons-wrapper"
  }, React.createElement("div", {
    className: "eurojackpot-play-buttons"
  }, React.createElement("h2", {
    className: "eurojackpot-play-buttons-title"
  }, drawTitle), React.createElement("div", {
    className: "eurojackpot-play-buttons-grid"
  }, sortedPlayPackages.map((_ref, i) => {
    let {
      rows
    } = _ref;
    const price = rows * rowPrice;
    return React.createElement("button", {
      className: "eurojackpot-play-button"
      ,
      key: i,
      onClick: () => handleClick(rows, price),
      type: "button"
    }, React.createElement("p", {
      className: "button-title"
    }, "".concat(rows, " rader")), React.createElement("h3", {
      className: "button-price"
    }, "".concat(price, " kr")));
  }))));
};
setGlobal('svs.eurojackpot.react.components', {
  PlayButtons
});

 })(window);